import ReactApexChart from "react-apexcharts";

// Espera `inscriptions` con la forma que devuelve
// inscription/getInscriptionsByMonthForYear: [{ name: categoryName, data: [12 números] }, ...]
export const MonthInscriptionsChart = ({ inscriptions, colors }) => {
  const months = [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ];

  const chartDataBar = {
    series: inscriptions,
    options: {
      chart: {
        type: "bar",
        height: 350,
        stacked: true,
        toolbar: {
          show: true,
        },
        zoom: {
          enabled: true,
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0,
            },
          },
        },
      ],
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 10,
          dataLabels: {
            total: {
              enabled: true,
              style: {
                fontSize: "13px",
                fontWeight: 900,
              },
            },
          },
        },
      },
      xaxis: {
        categories: months,
      },
      colors: colors,

      legend: {
        position: "right",
        offsetY: 40,
      },
      fill: {
        opacity: 1,
      },
    },
  };

  return (
    <div style={{ overflowX: "auto", maxWidth: "100%" }}>
      <ReactApexChart
        options={chartDataBar.options}
        series={chartDataBar.series}
        type="bar"
        height={300}
      />
    </div>
  );
};
